import BaseAnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";

export function SetSymbolEffects(symbols: SymbolComponent[], color: number, filters: Array<PIXI.Filter<any>>, behaviourNames: string[]) {
    symbols.forEach((symbol) => {
        behaviourNames.forEach((behaviourName) => {
            const behaviour = symbol.getBehaviourByName<BaseAnimateSymbolBehaviour>(behaviourName);

            if (behaviour) {
                if (filters.length) {
                    behaviour.filters = filters;
                } else {
                    behaviour.tintColor = color;
                }
            }
        });
    });
}
